// Webpack Imports
import * as bootstrap from 'bootstrap';

if(!$('body').hasClass('.trp-editor-body')) {
    ( function () {
        'use strict';

        // Focus input if Searchform is empty
        [].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
            el.addEventListener( 'submit', function ( e ) {
                var search = el.querySelector( 'input' );
                if ( search.value.length < 1 ) {
                    e.preventDefault();
                    search.focus();
                }
            } );
        } );

        // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
        var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
        var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
            return new bootstrap.Popover( popoverTriggerEl, {
                trigger: 'focus',
            } );
        } );
    } )();

    // Body class add on dom loaded
    document.addEventListener("DOMContentLoaded", function() {
        setTimeout(function(){
        // Select 2
        if($('select').length && $('body').hasClass('page-template-contact-sales')) {
            $('select').select2({
                placeholder: "Select...",
                allowClear: false
            });

            $('select[name="company-size"]').select2({
                minimumResultsForSearch: -1
            });
        }
            document.body.classList.add('dom-loaded');
        },200);


        const forbiddenZone =
            Intl.DateTimeFormat()
                .resolvedOptions()
                .timeZone.indexOf("Asia/Calcutta") == 0 ||
            Intl.DateTimeFormat()
                .resolvedOptions()
                .timeZone.indexOf("Asia/Karachi") == 0 ||
            Intl.DateTimeFormat()
                .resolvedOptions()
                .timeZone.indexOf("Asia/Dhaka") == 0;
        if (forbiddenZone) {
            document.querySelector('input[type="submit"]').value = "Send";
            if($('#sales-schedule-demo')) {
                document.getElementById("sales-schedule-demo").style.display = "none";
            }
        } else {
            if($('#sales-get-touch').length) {
                document.getElementById("sales-get-touch").style.display = "none";
            }
        }

        if(document.location.pathname.includes('/contact/sales')){
            document.addEventListener(
                "wpcf7mailsent",
                function (event) {
                    const data = getFormValues();
                    const isValid = !!data;
                    if (isValid) {
                        sendData(data, !forbiddenZone); // our custom submit
                    }
                },
                false
            );
        }
        

    });

    function getFormValues() {
        let yourName;
        let yourEmail;
        let yourRole;
        let yourSubject;
        let companySize;
        let country;
        let textarea210;
        let bundleOption;
        let workspaceId;
        let file443;

        const checkbox111 = [];

        try {
            yourName = document.querySelectorAll('[name="your-name"]')[0].value;
            yourEmail = document.querySelectorAll('[name="your-email"]')[0].value;
            yourRole = document.querySelectorAll('[name="your-role"]')[0].value;
            yourSubject = document.querySelectorAll('[name="your-subject"]')[0]
                .value;
            companySize = document.querySelectorAll('[name="company-size"]')[0]
                .value;
            bundleOption = document.querySelectorAll('[name="bundle-interest"]')[0]
                .value;
            workspaceId = document.querySelectorAll('[name="workspaceId"]')[0]
                .value;
            country = document.querySelectorAll('[name="country"]')[0].value;
            textarea210 = document.getElementsByTagName("textarea")[0].value;
            file443 = document.querySelectorAll("[type=file]")[0].value;

            // Checkboxes
            document.querySelectorAll("[type=checkbox]").forEach((element) => {
                if (!element.checked) return;
                if (element.value === "Other") return;
                if (element.name === "checkbox-111[]") {
                    checkbox111.push(element.value);
                }
            });
            // Checkboxes "Others"
            const freeText111 = document.querySelectorAll(
                '[name="checkbox-111_free_text"]'
            );
            const other111Value =
                freeText111 && freeText111[0] && freeText111[0].value;
            if (other111Value) {
                checkbox111.push(other111Value);
            }
        } catch (e) {
            console.error("Form parsing failed!!!");
            console.error(e);

            return null;
        }

        return {
            ["name"]: yourName,
            ["emailAddress"]: yourEmail,
            ["title"]: yourRole,
            ["companyName"]: yourSubject,
            ["companyHeadcount"]: companySize,
            ["country"]: country,
            ["bundleOption"]: bundleOption,
            ["workspaceId"]: workspaceId,
            ["description"]: textarea210,
            ["fileAttached"]: !!file443,
            ["tag"]: (bundleOption === "Only Clockify") ? "sales form" : "sales-form-bundle",
            ["contactReason"]: checkbox111.join(", "),
        };
    }

    function sendData(data, redirectCalendly) {

        fetch('https://crm-api.cake.com/sales/contact', {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            },
        }).finally(() => redirectToCalendly(data.companyHeadcount, data.bundleOption, redirectCalendly));

    }

    function redirectToCalendly(size, bundleOption, redirectCalendly) {
        if (!redirectCalendly) return;

        const CAKE_BUNDLE_URL_SMALL = "https://calendly.com/cake-com/cake-com-bundle-demo-30min";
        const CAKE_BUNDLE_URL_LARGE = "https://calendly.com/cake-com/bundle-demo";
        const CLOCKIFY_URL_SMALL = "https://calendly.com/clockify-sales/clockify-demo-call-30-min";
        const CLOCKIFY_URL_LARGE = "https://calendly.com/clockify-sales/demo";

        let url = "";

        if (bundleOption === "CAKE.com Bundle (Clockify + Pumble + Plaky)") {
            url = (size === "1-10" || size === "11-50") ? CAKE_BUNDLE_URL_SMALL : CAKE_BUNDLE_URL_LARGE;
        } else if (bundleOption === "Only Clockify") {
            url = (size === "1-10" || size === "11-50") ? CLOCKIFY_URL_SMALL : CLOCKIFY_URL_LARGE;
        }

        if (url) {
            window.location.href = url;
        }
    }

    // Custom CTA for submit field
    if($('body').hasClass('page-template-contact-sales')) {
        if($('.contact-sales-wrap__form').find('input[type="submit"]').length) {
            $('.contact-sales-wrap__form').find('input[type="submit"]').wrap('<div class="contact-form-button-wrapper"></div>');
        }
    }

    if($('body').hasClass('page-template-contact')) {
        if($('.contact-page-form').find('input[type="submit"]').length) {
            $('.contact-page-form').find('input[type="submit"]').attr('value', 'Send message');
            $('.contact-page-form').find('input[type="submit"]').wrap('<div class="contact-form-button-wrapper"></div>');
        }
    }

    // Category menu
    if($('.post-header').find('.primary-menu-wrapper').length) {
        $('.primary-menu-wrapper').find('.dropdown-menu').each(function() {

        });
    }

    // Detect OS
    function checkOperatingSystem() {
        var  userAgent = navigator.userAgent || navigator.vendor || window.opera;

        //Check mobile device is Android
        if (/android/i.test(userAgent)) {
            $('body').addClass('mobile');
        }

        //Check mobile device is IOS
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            $('body').addClass('mobile');
        }

        //Check device os is MAC (For Laptop and PC)
        if (navigator.appVersion.indexOf("Mac")!=-1) {
            $('body').addClass('mac-os');
        }  
    }

    checkOperatingSystem();
}

// Search trigger mobile
if ($(window).width() < 991 && $('form.search-form').length) {
	$('form.search-form').find('input.form-control').attr('placeholder', 'Search the Help Center');
	$('form.search-form').find('input.form-control').attr('placeholder', 'Search the Help Center');
}



const asideBarLists = document.querySelectorAll('.aside-bar-list');
const accTOCbody = document.getElementById('accordion-toc-body');

asideBarLists.forEach((list) => {
    const asideBarLinks = list.querySelectorAll('li a');
    if (asideBarLinks) {
        asideBarLinks.forEach((item) => {
            item.addEventListener('click', function() {
                asideBarLinks.forEach((item) => {
                    item.classList.remove('active');
                });
                item.classList.add('active');
                accTOCbody.classList.remove('show');
            });
        });
    }
});
// Close the TOC accordion on click anywhere
document.addEventListener('click', function() {
    if (accTOCbody) {
        accTOCbody.classList.remove('show');
    }
});

// Header search form
document.addEventListener("DOMContentLoaded", () => {
    const searchIcons = document.querySelectorAll('.search-trigger');
    const headerSearchInputs = document.querySelectorAll('.mobile-search');
    const homePageSearchInput = document.querySelector('.home-page-search-input');

    if (searchIcons.length && headerSearchInputs.length) {
        searchIcons.forEach((icon) => {
            icon.addEventListener('click', () => {
                headerSearchInputs.forEach((input) => input.classList.toggle('show'));

                const mobileSearchTrigger = icon.classList.contains('mobile-search-trigger');
                if (mobileSearchTrigger) {
                    icon.classList.toggle('active');
                }
            });
        });
    }

    if (homePageSearchInput && window.innerWidth < 991) {
        homePageSearchInput.placeholder = 'Search the Help Center';
    }

    
});